import { Component, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { UploadMasterService } from '../../../Model/UploadMaster/upload-master.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { LoaderComponent } from '../../Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import * as XLSX from 'xlsx';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertWarningComponent } from '../../Alert/alert-warning/alert-warning.component';
import { SessionService } from '../../../Util/Session/session.service';
import { AlertSuccessComponent } from '../../Alert/alert-success/alert-success.component';
import { ConfirmationComponent } from '../../Confirmation/confirmation/confirmation.component';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-upload',
  standalone: true,
  imports: [DataTablesModule, FormsModule, CommonModule, RouterModule, LoaderComponent, NgSelectModule],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss'
})
export class UploadComponent {
  isDisabled: boolean = false;
  uploadfile = null as any;
  ExcelHeaders = [{
    ESS_ExcelUploadMasterID: 1,//ShiftMaster
    Headers: ['ShiftMasterid', 'ShiftCode', 'ShiftTitle', 'InTime', 'OutTime', 'DefaultShift', 'RotationalShift	ShiftGroupName'],
  }, {
    ESS_ExcelUploadMasterID: 2,//ShiftGroupMaster
    Headers: ['ESS_ShiftGroupMasterID', 'ShiftGroupName'],
  }, {
    ESS_ExcelUploadMasterID: 3,//RoleMaster
    Headers: ['WebESSRoleMasterID', 'RoleName'],
  }, {
    ESS_ExcelUploadMasterID: 4,//SiteTypeMaster
    Headers: ['SiteTypeMasterID', 'SiteTypeName'],
  },];

  excelcheck = false;
  allowsubmit = false;
  Masters = [] as any;
  ////////
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  Filter = {
    SelectType: "S",
    ESS_ExcelUploadMasterId: null as any,
    UploadFileName: null,
    BatchNo: null,
    DataStatus: null,
    FileStatus: null,

    CompanyCode: null,
    UserId: null,
    MasterName: null,
  }

  Card = {
    Total: 0,
    Uploaded: 0,
    Success: 0,
    Fail: 0,
  }

  TableData = [];

  constructor(
    private uploadMaster: UploadMasterService,
    protected common: CommonService,
    private toast: ToastService,
    private modalService: NgbModal,
    private employeeRegistration: EmployeeRegistrationService,
    private session: SessionService,
    private download: DownloadSampleService,
  ) {
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_AdditionalFillCombo();
    this.ESS_ExcelUploadFileLogsLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.Filter.CompanyCode = this.session.GetUserDetails().CompanyCode;
    this.Filter.UserId = this.session.GetUserDetails().UserId;
  }


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_ExcelUploadFileLogsLoad() {
    this.isDisabled = true;
    this.TableData = [];
    this.Card.Total = 0;
    this.Card.Uploaded = 0;
    this.Card.Success = 0;
    this.Card.Fail = 0;
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
    this.uploadMaster.ESS_ExcelUploadFileLogsLoad(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableData = Object.values(response.Table);
          this.Card.Total = response.Table.length;
          this.Card.Uploaded = response.Table.filter((e: any) => this.common.ToLowerCase(e.FileStatus) == 'uploaded').length;
          this.Card.Success = response.Table.filter((e: any) => this.common.ToLowerCase(e.FileStatus) == 'success').length;
          this.Card.Fail = response.Table.filter((e: any) => this.common.ToLowerCase(e.FileStatus) == 'fail').length;
        }
        try {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ////
  handleFileInputChange(event: any): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadfile = file;
      input.value = '';
    } else {
      this.uploadfile = null;
      console.log('No file selected or file selection cancelled');
    }
  }

  uploadfileData() {
    if (this.Filter.ESS_ExcelUploadMasterId == null || this.Filter.ESS_ExcelUploadMasterId < 0) {
      this.toast.show({ message: 'Please select master.', type: toastTypeEnum.warning });
    } else if (this.uploadfile == null) {
      this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.warning });
    } else {
      this.handleFileInput()
    }
  }

  handleFileInput(): void {
    const file: File = this.uploadfile;
    const fileType: string | undefined = file.name.split('.').pop();
    if (fileType !== 'xlsx' && fileType !== 'xls') {
      this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
      return;
    }
    this.processExcelFile(file);
  }

  processExcelFile(file: File): void {
    this.isDisabled = true;
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        if (excelData.length > 1) {
          const headerRow = excelData[0];
          const headers = headerRow.map((header: string) => header.trim());
          this.allowsubmit = false;
          this.excelcheck = true;

          if (this.ExcelHeaders.filter(e => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId).length > 0) {
            this.ExcelHeaders.filter(e => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId)[0].Headers.forEach(element => {
              if (this.excelcheck) {
                if (headers.findIndex(e => this.common.ToLowerCase(e) == this.common.ToLowerCase(element)) >= 0) {
                  this.excelcheck = true;
                } else {
                  this.excelcheck = false;
                }
              }

              if (!this.excelcheck) {
                return;
              }
            });
          }

          if (!this.excelcheck) {
            this.reset();
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Excel file column not match. please check sample file";
            modalRef.result.then((result: any) => { });
          } else {
            this.allowsubmit = true;
            this.submit();
          }
          this.isDisabled = false;
        } else {
          this.reset();
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Excel file have a no data";
          modalRef.result.then((result: any) => { });
        }
      } else {
        console.error('Failed to read the file.');
        this.isDisabled = false;
      }
    };
    reader.readAsBinaryString(file);
  }

  reset() {
    this.isDisabled = false;
    this.allowsubmit = false;

    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.clear().draw();
      });
    }
    this.removeFile();
  }

  removeFile() {
    this.setallowsubmit();
    this.uploadfile = null;
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.Masters = [];

    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'ESS_ExcelUploadMaster', UserId: this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Masters = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  submit() {
    if (this.allowsubmit) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(result => {
        if (result) {
          this.isDisabled = true;
          this.Filter.MasterName = this.Masters.filter((e: any) => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId)[0].ExcelUploadName;
          this.uploadMaster.CommonMasterExcelupload(this.uploadfile, this.Filter).subscribe({
            next: (response) => {
              if (response.Error_Code == "874") {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.reset();
                    this.ESS_ExcelUploadFileLogsLoad();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }

              this.isDisabled = false;
            },
            complete: () => {
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    }
  }

  downloadExcel() {
    if (this.Filter.ESS_ExcelUploadMasterId > 0) {
      this.download.downloadExcel(this.Masters.filter((e: any) => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId)[0].SampleFileName.split('.')[0]);
    } else {
      this.toast.show({ message: 'Please select master.', type: toastTypeEnum.warning });
    }
  }

  setallowsubmit() {
    this.allowsubmit = false;
  }
}
